import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Label } from 'reactstrap'
import OperatorInput from './OperatorInput'
import StateInput from './StateInput'
import CountryInput from './CountryInput'
import useForm from '../CustomHooks/FormHook'
import { OBJECT_TYPE } from '../CustomCode/FwContracts/fwconstracts_constants'
import './Custom.css'
import { initialFormValues, stringifyInputs } from './CustomUtils'
import { enterKeyHandler, setSessionStorage, getTenant } from '../../utils'
import FormSubmitButton from './FormSubmitButton'
import FormHeading from './FormHeading'

export default function CrossEntityReportForm({ location }) {
  console.log('CrossEntityReportForm rendered: ', location)

  let init = {
    docType: [],
    operator: 'C',
    company: '',
    city: '',
    state: '',
    country: '',
    plOperator: 'C',
    plaintiff: '',
    date: '',
    osr: 'on'
  }

  const tenant = getTenant()
  const navigate = useNavigate()
  init = initialFormValues('fwcontracts.cross_entity_search', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('CrossEntityReportForm.submitSearch', inputs)

    setSessionStorage('fwcontracts.cross_entity_search', JSON.stringify(inputs))

    if (inputs.osr) {
      inputs.docType.push(`${OBJECT_TYPE.osr}`)
    }
    if (inputs.contract) {
      inputs.docType.push(`${OBJECT_TYPE.letters}`)
    }
    if (inputs.jobsite) {
      inputs.docType.push(`${OBJECT_TYPE.jobsiteReferences}`)
    }
    if (inputs.fw) {
      inputs.docType.push(`${OBJECT_TYPE.fwInfostore}`)
    }
    if (inputs.production) {
      inputs.docType.push(`${OBJECT_TYPE.productionDocuments}`)
    }

    delete inputs.osr
    delete inputs.contract
    delete inputs.jobsite
    delete inputs.fw
    delete inputs.production
    
    let queryString = `/custom/fwcontracts.cross_entity_search?inputs=${stringifyInputs(inputs)}`
    navigate(queryString)
  }

  let recordType = ''
  let companyNotes = ''
  let locationNotes = ''
  let plaintiff = ''
  let date = ''
  if (location.search === '') {
    recordType =
      <tr >
        <td><Label><b>Record Type</b></Label></td>
        <td>
          <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.osr} name="osr" onChange={handleInputChange} /> OSR <span><br /></span>
          <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.contract} name="contract" onChange={handleInputChange} /> Contract and Production Transmittal Letters <span><br /></span>
          <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.jobsite} name="jobsite" onChange={handleInputChange} /> Jobsite References <span><br /></span>
          <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.fw} name="fw" onChange={handleInputChange} /> FW Infostore <span><br /></span>
          <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.production} name="production" onChange={handleInputChange} /> Production Documents <span><br /></span>
        </td>
      </tr>
    companyNotes =
      <React.Fragment>
        <span><br /><br /></span>
        <b>Note:</b>  For " Production Documents", this field searches the "Vessel or Location Name" text. <span><br /></span>
          For "Jobsite References", this field searches the "Company/Site/Vessel" text and the "Station, Refinery, Mill, Etc" text
      </React.Fragment>
    locationNotes =
      <React.Fragment>
        <span><br /></span>
        <b>Note:</b> For "Production Documents", these fields search the "Vessel or Location Name" text.
      </React.Fragment>
    plaintiff =
      <tr>
        <td><b>Plaintiff</b></td>
        <td>
          <Input style={{ width: 'auto', display: 'inline-block' }} type="select" name="plOperator" className="operator-input" onChange={handleInputChange} defaultValue={inputs.plOperator}>
            <option key={0} value={'C'}>Contains</option>
            <option key={1} value={'S'}>Starts With</option>
            <option key={2} value={'E'}>Equals</option>
          </Input>
          <Input className="custom-input" name="plaintiff" onChange={handleInputChange} defaultValue={inputs.plaintiff} /> <span><br /><br /></span>
          <b>Note:</b> This search field only applies to "Contract and Production Transmittal Letters" and "Jobsite References".
        </td>
      </tr>
    date =
      <tr>
        <td><Label><b>Date</b></Label></td>
        <td>
          <Input style={{ display: 'inline-block', width: 'auto' }} type='date' name='date' onChange={handleInputChange} defaultValue={inputs.date} /> <span><br /><br /></span>
          <b>Note:</b> This search field only applies to "Contract and Production Transmittal Letters" and "Jobsite References".
        </td>
      </tr>
  }
  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <FormSubmitButton label="Search" />
        <div>
          <Table bordered className="custom-table custom-form-table">
            <FormHeading headingText="Search" />
            <tbody>
              {recordType}
              <tr>
                <td><b>Company</b></td>
                <td>
                  <OperatorInput handleChange={handleInputChange} defaultValue={inputs.operator} />
                  <Input className="custom-input" size="50" name="company" onChange={handleInputChange} defaultValue={inputs.company} />
                  {companyNotes}
                </td>
              </tr>
              <tr>
                <td><b>Location</b></td>
                <td>
                  <b>City</b><span><br /></span>
                  <Input style={{ display: 'inline-block', width: 'auto' }} size="50" name="city" onChange={handleInputChange} defaultValue={inputs.city} />
                  <span><br /><br /></span>
                  <b>State/Province</b><span><br /></span>
                  <StateInput tenant={tenant} handleChange={handleInputChange} defaultValue={inputs.state} />
                  <span><br /><br /></span>
                  <b>Country</b><span><br /></span>
                  <CountryInput handleChange={handleInputChange} defaultValue={inputs.country} />
                  <span><br /></span>
                  {locationNotes}
                </td>
              </tr>
              {plaintiff}
              {date}
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Search" />
      </form>
    </div>
  )
}
